import Organization from "../models/Organization";
import OrganizationRepository from "./OrganizationRepository";

class UserRepository {
    normalizeId = (value) => (value == null ? null : String(value).toLowerCase());

    formatUserResponse = (user) => {
        const { userDetails, orgCollection } = user;

        let organizations = Organization.format(orgCollection);
        let policies = OrganizationRepository.getPolicies(organizations);

        return { userDetails, organizations, policies };
    };

    formatOdsUserResponse = (odsResponse) => {
        const odsUserData = odsResponse ?? {};
        const assignedOrgs = Array.isArray(odsUserData.assignedOrgsList)
            ? odsUserData.assignedOrgsList
            : [];
        const internalUserInd = odsUserData?.internalUserInd;
        let isUserInternal = internalUserInd;

        if (internalUserInd === "Y") {
            isUserInternal = true;
        } else if (internalUserInd === "N") {
            isUserInternal = false;
        }

        const organizations = assignedOrgs.map((org) => ({
            ORGANIZATIONGROUPID: this.normalizeId(org.orgGroupId),
            ORGANIZATIONID: this.normalizeId(org.orgId),
            ORGANIZATIONIDISF: this.normalizeId(org.orgId),
            ORGNIZATIONNAME: org.orgName,
            ORGANIZATIONGROUPNAME: org.orgGroupName,
            POLICYID: Array.isArray(org.assignedPolicies)
                ? org.assignedPolicies
                      .map((policy) =>
                          typeof policy === "string" ? policy : policy?.policyId
                      )
                      .filter(Boolean)
                      .join(",")
                : org.assignedPolicies,
        }));

        const policies = OrganizationRepository.getPolicies(organizations);
        const userDetails = {
            userId: odsUserData?.userIdentifier,
            userEmail: odsUserData?.userEmail,
            userFirstName: odsUserData?.userFirstName,
            userLastName: odsUserData?.userLastName,
            isUserInternal,
            partyIdentifier: odsUserData?.userIdentifier,
        };

        return { organizations, policies, userDetails };
    };
}

export default new UserRepository();
